module.exports = __webpack_public_path__ + "img/overheads-dues-and-subscriptions.c6332845.svg";